import React, {useState} from "react";
import Autocomplete from "react-google-autocomplete";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import BackButton from '../../../Components/BackToPrev'
import { useNavigate } from "react-router-dom";
import CityListButton from "../../../Components/City/CityListButton";
import { constants } from "../../../lib/constants";
import { addDestination } from "../../../Services/admin-service";

const AddCity = () => {
    
    
    const navigate = useNavigate();
    const [placeSelected,setPlaceSelected] = useState();

    const handleSubmit = () => {
        if(placeSelected != undefined){
            const payload = {
                locationName: placeSelected.formatted_address,
                address: placeSelected.formatted_address,
                lat: placeSelected.geometry.location.lat(),
                long: placeSelected.geometry.location.lng(),
                city: "",
                state: "",
                country: "",
                type: "city",
            }
            placeSelected.address_components.forEach(val => {
                if(val.types[0] == "locality")
                    payload.city = val.long_name
                else if(val.types[0] == "administrative_area_level_1")
                    payload.state = val.long_name
                else if(val.types[0] == "country")
                    payload.country = val.long_name
            })

            addDestination(payload)
            .then((res) => {
                toast.success("City Added", {
                    position: toast.POSITION.BOTTOM_RIGHT
                  });
            }).catch((err) => {
                toast.error(err.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                  });
            })            

        }else{
            toast.error("Please select City", {
                position: toast.POSITION.BOTTOM_RIGHT
              });
        }
            
    }

    const citySelected = (data) => {        
        setPlaceSelected(data)
    }

    return(
        <>
        <ToastContainer />
        <div className=''>
                <div className='top-header'>
                    <div className='page-name'>
                        <BackButton />
                        <h4>Add City</h4>
                    </div>
                    <div className='import-export'>
                        <CityListButton />
                    </div>
                </div>

                <div className="serachbar-box">
                    <div className="searchbar">
                    <Autocomplete className="border-l p-2 px-4 w-100 rounded-3" onChange={e => {setPlaceSelected();}} apiKey={constants.GOOGLE_API} types={["locality"]} onPlaceSelected={citySelected} />
                    </div>
                    <button className="btn btn-secondary" onClick={handleSubmit}>Add City</button>
                </div>
                
            </div>
        </>
    )
}

export default AddCity
